import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { NotificationCountType } from '@/models/Notification';

import useI18n from '@/mixins/useI18n';
import useNotificationActions from '@/components/toolbar/notification/useNotificationActions';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPanelItemLabel',
  props: {
  type: {
    type: String as PropType<NotificationCountType>,
    required: true
  }
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const { getRoute, gotoItem } = useNotificationActions();



const label = computed(() => t(`notifications.${props.type}`));

const route = computed(() => getRoute(props.type));

return { __sfc: true,t, getRoute, gotoItem, props, label, route }
}

})